import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../BaseUrl"; 

const initialState = {
    unauthorized: true,
    loading: false,
    error: '',
    success: false,
    claimList: [],
    reasonList:[], 
    details:false,
    customerChat:[], 
    providerChat:[], 
    resolutionType:[], 
    statusList:[],
    dispute_logs:[],

    supportCenterButton: [],
    supportCenterButtonFetched: false,
    supportCenterCategory: [],
    supportCenterCategoryFetched: false,
    supportCenterDocument: [],
    supportCenterDocumentFetched: false,
    targetPlatforms :false,
}

const url = `${BASE_URL}/support`
const url2 = `${BASE_URL}/supportcentre`

const token = localStorage.getItem("token")
// const textId = localStorage.getItem("textId")

const config = {
    headers: {
        Authorization: `Token ${token}`, 
    }
}
// const jsonConfig = {
//     headers: {
//         Authorization: `Token ${token}`,
//         // 'Content-Type': "multipart/form-data",
//     }
// }
 const multipartConfig = {
        headers: {
          Authorization: `Token ${token}`,
          // 'Content-Type': 'multipart/form-data',
        }
      };
 

  
const buildSupportCenterButtonFormData = (data) => {
  const formData = new FormData();

  if (data?.title !== undefined) formData.append("title", data.title);
  if (data?.answer !== undefined) formData.append("answer", data.answer);
  if (data?.details !== undefined) formData.append("details", data.details);
  if (data?.target_platform !== undefined) formData.append("target_platform", data.target_platform);
  if (data?.status !== undefined) formData.append("status", data.status);
  if (data?.id !== undefined) formData.append("id", data.id);
  if (data?.textId !== undefined) formData.append("textId", data.textId);
  if (data?.rank !== undefined) formData.append("rank", data.rank);
  if (data?.categoryTextId !== undefined) formData.append("categoryTextId", data.categoryTextId);
  if (data?.mediaFiles !== undefined) formData.append("mediaFiles", data.mediaFiles);

  if (Array.isArray(data?.tags)) {
    data.tags.forEach((tag) => formData.append("tags", tag));
  }

  if (Array.isArray(data?.images)) {
    data.images.forEach((file) => {
      if (file instanceof File) {
        formData.append("images", file);
      }
    });
  }

  if (Array.isArray(data?.existingImages)) {
    data.existingImages.forEach((url) => {
      // formData.append("images", url);
      formData.append("existingImages", url);
    });
  }
  if (Array.isArray(data?.file)) {
    data.file.forEach((file) => {
      if (file instanceof File) {
        formData.append("file", file);
      }
    });
  }

  if (Array.isArray(data?.existingFile)) {
    data.existingFile.forEach((url) => {
      // formData.append("images", url);
      formData.append("existingFile", url);
    });
  }

  // if (Array.isArray(data?.mediaFiles)) {
  //   data.mediaFiles.forEach((url) => {
  //     formData.append("mediaFiles", url);
  //   });
  // }
  console.log('FormData entries:', [ ...formData.entries()]);

  return formData;
};

const buildSupportCenterDocumentFormData = (data) => {
  const formData = new FormData();


  
  if (data?.title !== undefined) formData.append("title", data.title);
  // if (data?.answer !== undefined) formData.append("answer", data.answer); 
  if (data?.target_platform !== undefined) formData.append("target_platform", data.target_platform);
  if (data?.status !== undefined) formData.append("status", data.status); 
  if (data?.description !== undefined) formData.append("description", data.description); 
  if (data?.rank !== undefined) formData.append("rank", data.rank);

 
  // IMPORTANT: append actual file object
  if (data.mediaFiles) { 
    formData.append("mediaFiles", data.mediaFiles);
  }
  console.log('Document FormData entries:', [ ...formData.entries()]);

  return formData;
};

export const fetchInvoice = createAsyncThunk(
    'fetch/getInvoiceData', async () => {
        return axios
        .get(`${url}/dispute-claim-list/`, config)
        .then((response) => response.data)
    }
)

export const fetchClaimReason = createAsyncThunk(
    'fetch/fetchClaimReason', async () => {
        return axios
        .get(`${url}/dispute-reason/`, config)
        .then((response) => response.data)
    }
)

 

// export const fetchClaimResolution = createAsyncThunk(
//     'fetch/fetchClaimResolution', async () => {
//         return axios
//         .get(`${url}/dispute-resolution/`, config)
//         .then((response) => response.data)
//     }
// )
// export const fetchClaimStatus = createAsyncThunk(
//     'fetch/fetchClaimStatus', async () => {
//         return axios
//         .get(`${url}/dispute-status/`, config)
//         .then((response) => response.data)
//     }
// )

export const createClaimReason = createAsyncThunk(
    "post/createClaimReason", async (formData) => { 
        return axios
            .post(`${url}/dispute-reason/`, formData, config)
            .then((response) => response.data
            )
    }
)
export const testPost = createAsyncThunk(
    "post/testPost", async (formData) => { 
        return axios
            .post(`http://team.dev.helpabode.com:54292/api/wempro/react-dev/coding-test/nur1234@gmail.com`, formData, config)
            .then((response) => response.data
            )
    }
)
export const testGet = createAsyncThunk(
    'fetch/testGet', async () => {
        return axios
        .get(`http://team.dev.helpabode.com:54292/api/wempro/react-dev/coding-test/nur1234@gmail.com`, config)
        .then((response) => response.data)
    }
)
export const updateClaimReason = createAsyncThunk(
  "put/updateClaimReason", async (formData) => { 
    console.log(formData)
    return axios
    .put(`${url}/dispute-reason/?textId=${formData.textId}`, formData, config)
    .then((response) => response.data
    )
  }
) 
export const deleteClaimReason = createAsyncThunk(
  "delete/deleteClaimReason", async (formData) => { 
    return axios
    .delete(`${url}/dispute-reason/?textId=${formData.textId}&localIndex=${formData.localIndex}`, config)
    .then((response) => response.data
    )
  }
) 
export const updateClaimResolution = createAsyncThunk(
  "put/updateClaimResolution", async (formData) => { 
    console.log(formData)
    return axios
    .put(`${url}/dispute-resolution/?textId=${formData.textId}`, formData, config)
    .then((response) => response.data
    )
  }
) 

export const deleteClaimResolution = createAsyncThunk(
  "delete/deleteClaimResolution", async (formData) => { 
    return axios
    .delete(`${url}/dispute-resolution/?textId=${formData.textId}&localIndex=${formData.localIndex}`, config)
    .then((response) => response.data
    )
  }
) 

export const createClaimResolution = createAsyncThunk(
    "post/createClaimResolution", async (formData) => {
        return axios
            .post(`${url}/dispute-resolution/`, formData, config)
            .then((response) => response.data
            )
    }
)
// export const createClaimStatus = createAsyncThunk(
//     "post/createClaimStatus", async (formData) => {
       
//         // console.log(formData)
//         return axios
//             .post(`${url}/dispute-status/`, formData, config)
//             .then((response) => response.data
//             )
//     }
// )
export const fetchClaimDetails = createAsyncThunk(
    'fetch/OrderDetails', async (data) => {
      return axios
        .get(`${url}/dispute-claim-details/${data}/`, config)
        .then((response) => response.data)
    }
)
export const fetchDisputeChatlist = createAsyncThunk(
    'fetch/chatlist', async (data) => {
      return axios
        .get(`${url}/dispute-chatlist/${data}/`, config)
        .then((response) => response.data)
    }
)




export const updateDisputeClaim = createAsyncThunk(
  "post/updateDisputeClaim", async (formData) => { 
    return axios
    .post(`${url}/dispute-claim-update/`, formData, config)
    .then((response) => response.data
    )
  }
) 
export const disputeAssignProvider = createAsyncThunk(
  "put/disputeAssignProvider", async (formData) => {  
    return axios
    .post(`${url}/dispute-assign-provider/${formData}/`, formData, config)
    .then((response) => response.data
    )
  }
) 
export const disputeResolved = createAsyncThunk(
  "put/disputeResolved", async (formData) => {  
    return axios
    .post(`${url}/dispute-resolved/${formData}/`, formData, config)
    .then((response) => response.data
    )
  }
) 
export const disputeRequestMoreInfo = createAsyncThunk(
  "put/disputeRequestMoreInfo", async (formData) => {  
    console.log('formData: ', formData)
    return axios
    .post(`${url}/dispute-request-more-info/${formData.claimTextId}/`, formData, config)
    .then((response) => response.data
    )
  }
) 


export const fetchTargetPlatforms  = createAsyncThunk(
    'fetch/fetchTargetPlatforms', async (data) => {
      return axios
        .get(`${url2}/target_platforms/`, config)
        .then((response) => response.data)
    }
)

export const fetchSupportCenterButton  = createAsyncThunk(
    'fetch/fetchSupportCenterButton', async (data) => {
      return axios
        .get(`${url2}/predefine-ai-questions/`, config)
        .then((response) => response.data)
    }
)

export const postSupportCenterButton  = createAsyncThunk(
    'post/postSupportCenterButton', async (data) => {  
      const formData = buildSupportCenterButtonFormData(data);
      return axios
        .post(`${url2}/predefine-ai-questions/`, formData, multipartConfig)
        .then((response) => response.data)
    }
)
export const putSupportCenterButton  = createAsyncThunk(
    'put/putSupportCenterButton', async (data) => {  
      const formData = buildSupportCenterButtonFormData(data); 
      return axios
        .put(`${url2}/predefine-ai-questions/?textId=${data.textId}`, formData, multipartConfig)
        .then((response) => response.data)
    }
)
export const postSupportCategory  = createAsyncThunk(
    'post/postSupportCategory', async (data) => {  
      const formData = buildSupportCenterButtonFormData(data);
      console.log('Posting support category with formData: ', formData);
      return axios
        .post(`${url2}/predefine-support-category/`, formData, multipartConfig)
        .then((response) => response.data)
    }
)
export const putSupportCategory  = createAsyncThunk(
    'put/putSupportCategory', async (data) => {  
      const formData = buildSupportCenterButtonFormData(data); 
      return axios
        .put(`${url2}/predefine-support-category/?textId=${data.textId}`, formData, multipartConfig)
        .then((response) => response.data)
    }
)

export const deleteSupportCategory  = createAsyncThunk(
    'delete/deleteSupportCategory', async (data) => { 
      console.log('deleteSupportCategory data: ', data)
      return axios
        .delete(`${url2}/predefine-support-category/?textId=${data.textId}`, config)
        .then((response) => response.data)
    }
)

export const deleteSupportCenterButton  = createAsyncThunk(
    'delete/deleteSupportCenterButton', async (data) => { 
      console.log('deleteSupportCenterButton data: ', data)
      return axios
        .delete(`${url2}/predefine-ai-questions/?textId=${data.textId}`, config)
        .then((response) => response.data)
    }
)
 
export const fetchSupportCenterDocument  = createAsyncThunk(
    'fetch/fetchSupportCenterDocument', async (data) => {
      return axios
        .get(`${url2}/documents/`, config)
        .then((response) => response.data)
    }
)

export const postSupportCenterDocument  = createAsyncThunk(
    'post/postSupportCenterDocument', async (data) => {  
      // console.log('Posting document with data: ', data);
      const formData = buildSupportCenterDocumentFormData(data); 
      // console.log('Posting document with data: ', [ ...formData.entries()]);
      return axios
        .post(`${url2}/create/list/`, formData, multipartConfig)
        // .post(`${url2}/create/list/`, data, jsonConfig)
        .then((response) => response.data)
    }
)

export const putSupportCenterDocument  = createAsyncThunk(
    'put/putSupportCenterDocument', async (data) => {  
      const formData = buildSupportCenterDocumentFormData(data); 
      console.log('Updating document with data: ', [ ...formData.entries()]);
      return axios
        .put(`${url2}/documents/update/${data.textId}/`, formData, multipartConfig)
        .then((response) => response.data)
    }
)

export const deleteSupportCenterDocument  = createAsyncThunk(
    'delete/deleteSupportCenterDocument', async (data) => { 
      console.log('deleteSupportCenterDocument data: ', data)
      return axios
        .delete(`${url2}/documents/${data.textId}/`, config)
        .then((response) => response.data)
    }
)

const insertCategoryIntoTree = (categories, parentTree, newCategory) => {
  if (!Array.isArray(parentTree) || parentTree.length === 0) return false;

  const parentIds = parentTree
    .map((item) => item?.textId ?? item?.id ?? item)
    .filter(Boolean);

  if (parentIds.length === 0) return false;

  const targetId = parentIds[parentIds.length - 1];

  const traverse = (nodes) => {
    for (const node of nodes) {
      const nodeId = node?.textId ?? node?.id;
      if (nodeId === targetId) {
        if (!Array.isArray(node.children)) node.children = [];
        node.children.push(newCategory);
        return true;
      }
      if (Array.isArray(node.children) && node.children.length) {
        if (traverse(node.children)) {
          return true;
        }
      }
    }
    return false;
  };

  return traverse(categories);
};

const updateCategoryInTree = (categories, itemId, updatedData) => {
  const traverse = (nodes) => {
    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i];
      const nodeId = node?.textId ?? node?.id;
      
      if (nodeId === itemId) {
        nodes[i] = {
          ...node,
          ...updatedData,
        };
        return true;
      }
      
      if (Array.isArray(node.children) && node.children.length > 0) {
        if (traverse(node.children)) {
          return true;
        }
      }
    }
    return false;
  };

  return traverse(categories);
};
 
export const fetchSupportCenterCategory  = createAsyncThunk(
    'fetch/fetchSupportCenterCategory', async (data) => {
      return axios
        .get(`${url2}/predefine-support-category/`, config)
        .then((response) => response.data)
    }
)

 
  
const disputeClaimSlice = createSlice({
    name: "notification",
    initialState,
    reducers: {
      appendCustomerChatItem(state, action) {
        state.customerChat.push(action.payload);
      },
      appendProviderChatItem(state, action) {
        state.providerChat.push(action.payload);
      },
 
    },
    extraReducers: (builder) => {
    
      builder.addCase(fetchClaimDetails.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(fetchClaimDetails.fulfilled, (state, action) => {
        state.loading = false; 
        state.details = action.payload;
        state.dispute_logs = action.payload?.dispute_logs;
        state.error = "";
      });
      builder.addCase(fetchClaimDetails.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.error;
      });
 
      builder.addCase(disputeRequestMoreInfo.fulfilled, (state, action) => {
        state.loading = false; 
        state.dispute_logs = action.payload?.dispute_logs;
        state.error = "";
      });
      builder.addCase(disputeResolved.fulfilled, (state, action) => {
        state.loading = false; 
        state.dispute_logs = action.payload?.dispute_logs;
        state.error = "";
      });

      builder.addCase(updateDisputeClaim.fulfilled, (state, action) => {
        state.loading = false; 
        state.dispute_logs = action.payload?.dispute_logs;
        state.error = "";
      });
 
 


      builder.addCase(fetchInvoice.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(fetchInvoice.fulfilled, (state, action) => {
        state.loading = false; 
        state.claimList = action.payload.dispute_list;
        state.error = "";
      });
      builder.addCase(fetchInvoice.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.error;
      });


 
      builder.addCase(fetchDisputeChatlist.fulfilled, (state, action) => {
        state.loading = false; 
        state.customerChat = action.payload?.admin_to_user;
        state.providerChat = action.payload?.admin_to_provider;
        state.error = "";
        // console.log(action.payload)

    //         customerChat:[], 
    // providerChat:[],
      });
      builder.addCase(fetchDisputeChatlist.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.error;
      });
      

      builder.addCase(fetchClaimReason.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(fetchClaimReason.fulfilled, (state, action) => {
        state.loading = false; 
        state.reasonList = action.payload.disputeReason;
        state.resolutionType = action.payload.disputeResolution;
        state.statusList = action.payload.disputeStatus;
        state.error = "";
      });
      builder.addCase(fetchClaimReason.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.error;
      });

      builder.addCase(updateClaimReason.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(updateClaimReason.fulfilled, (state, action) => {
        state.loading = false; 
        state.reasonList[action.payload.localIndex] = action.payload.created_data;
        state.error = "";
      });
      builder.addCase(updateClaimReason.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.error;
      });

      builder.addCase(deleteClaimReason.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(deleteClaimReason.fulfilled, (state, action) => {
        state.loading = false; 
        state.reasonList.splice(action.payload.localIndex, 1);
        state.error = "";
      });
      builder.addCase(deleteClaimReason.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.error;
      });

      builder.addCase(updateClaimResolution.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(updateClaimResolution.fulfilled, (state, action) => {
        state.loading = false; 
        state.resolutionType[action.payload.localIndex] = action.payload.created_data;
        state.error = "";
      });
      builder.addCase(updateClaimResolution.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.error;
      });

      builder.addCase(deleteClaimResolution.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(deleteClaimResolution.fulfilled, (state, action) => {
        state.loading = false; 
        state.resolutionType.splice(action.payload.localIndex, 1);
        state.error = "";
      });
      builder.addCase(deleteClaimResolution.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.error;
      });

      // builder.addCase(fetchClaimResolution.pending, (state) => {
      //   state.loading = true;
      // });
      // builder.addCase(fetchClaimResolution.fulfilled, (state, action) => {
      //   state.loading = false; 
      //   state.resolutionType = action.payload.disputeResolution;
      //   state.error = "";
      // });
      // builder.addCase(fetchClaimResolution.rejected, (state, action) => {
      //   state.loading = false; 
      //   state.error = action.error;
      // });
       

      // builder.addCase(fetchClaimStatus.pending, (state) => {
      //   state.loading = true;
      // });
      // builder.addCase(fetchClaimStatus.fulfilled, (state, action) => {
      //   state.loading = false; 
      //   state.statusList = action.payload.disputeClaims;
      //   state.error = "";
      // });
      // builder.addCase(fetchClaimStatus.rejected, (state, action) => {
      //   state.loading = false; 
      //   state.error = action.error;
      // });

      builder.addCase(createClaimReason.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(createClaimReason.fulfilled, (state, action) => {
        state.loading = false; 
        // state.ReasonList = action.payload.created_data;
        state.reasonList.push(action.payload.created_data);
        state.error = "";
 
      });
      builder.addCase(createClaimReason.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.error;
      });
       
       

      builder.addCase(createClaimResolution.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(createClaimResolution.fulfilled, (state, action) => {
        state.loading = false;  
        state.resolutionType.push(action.payload.created_data);
        state.error = "";
 
      });
      builder.addCase(createClaimResolution.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.error;
      });

      builder.addCase(fetchTargetPlatforms.pending, (state) => {
        // state.loading = true;
      });
      builder.addCase(fetchTargetPlatforms.fulfilled, (state, action) => {
        state.loading = false;
        state.targetPlatforms = action.payload;
        state.error = "";
        console.log('Fetched target platforms: ', action.payload);
      });
      builder.addCase(fetchTargetPlatforms.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });


      builder.addCase(fetchSupportCenterButton.pending, (state) => {
        state.loading = true;
        state.supportCenterButtonFetched = true;
      });
      builder.addCase(fetchSupportCenterButton.fulfilled, (state, action) => {
        state.loading = false; 
        // console.log('action.payload: ', action.payload.predefine_ai_messages)
        state.supportCenterButton = action.payload?.predefine_ai_messages;
        state.supportCenterButtonFetched = true;
        state.error = "";
      });
      builder.addCase(fetchSupportCenterButton.rejected, (state, action) => {
        state.loading = false; 
        state.supportCenterButtonFetched = true;
        state.error = action.error;
      });

      builder.addCase(postSupportCenterButton.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(postSupportCenterButton.fulfilled, (state, action) => {
        state.loading = false; 
        console.log('Post Success: ', action.payload);
        state.supportCenterButton.unshift(action.payload.created_data);
        state.error = "";
      });
      builder.addCase(postSupportCenterButton.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.error;
      });

      builder.addCase(putSupportCenterButton.pending, (state) => {
        // state.loading = true;
      });
      builder.addCase(putSupportCenterButton.fulfilled, (state, action) => {
        // state.loading = false; 
        console.log('Put Success: ', action.payload);

        const payload = action.payload?.created_data || action.payload?.updated_data || action.payload;
        const payloadId = payload?.textId || payload?.id;
        const index = state.supportCenterButton.findIndex(item => item.textId === payloadId || item.id === payloadId);
        console.log('Index to update: ', index, 'payloadId:', payloadId);

        if (index !== -1) {
          const existingItem = state.supportCenterButton[index];
          const updatedItem = {
            ...existingItem,
            ...payload,
          };

          if ((!updatedItem.mediaFiles || updatedItem.mediaFiles === '[]') && existingItem.mediaFiles) {
            updatedItem.mediaFiles = existingItem.mediaFiles;
          }

          state.supportCenterButton[index] = updatedItem;
        }

        state.error = "";
      });
      builder.addCase(putSupportCenterButton.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.error;
      });

      builder.addCase(deleteSupportCenterButton.pending, (state) => {
        // state.loading = true;
      });
      builder.addCase(deleteSupportCenterButton.fulfilled, (state, action) => {
        // state.loading = false; 
        console.log('Delete Success: ', action.payload);
        const textId = action.meta.arg?.textId;
        state.supportCenterButton = state.supportCenterButton.filter(item => item.textId !== textId);
        state.error = "";
      });
      builder.addCase(deleteSupportCenterButton.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.error;
      });

      builder.addCase(fetchSupportCenterCategory.pending, (state) => {
        state.loading = true;
        state.supportCenterCategoryFetched = true;
      });
      builder.addCase(fetchSupportCenterCategory.fulfilled, (state, action) => {
        state.loading = false; 
        // console.log('action.payload: ', action.payload)
        state.supportCenterCategory = action.payload?.predefine_support_categories;
        state.supportCenterCategoryFetched = true;
        state.error = "";
      });
      builder.addCase(fetchSupportCenterCategory.rejected, (state, action) => {
        state.loading = false; 
        state.supportCenterCategoryFetched = true;
        state.error = action.error;
      });

      builder.addCase(postSupportCategory.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(postSupportCategory.fulfilled, (state, action) => {
        state.loading = false; 
        console.log('Post Category Success: ', action.payload);

        const createdData = action.payload?.created_data || action.payload;
        const parentTree = createdData?.parent_tree;

        if (Array.isArray(parentTree) && parentTree.length > 0) {
          const inserted = insertCategoryIntoTree(state.supportCenterCategory, parentTree, createdData);
          if (!inserted) {
            state.supportCenterCategory.push(createdData);
          }
        } else {
          state.supportCenterCategory.push(createdData);
        }

        state.error = "";
      });
      builder.addCase(postSupportCategory.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.error;
      });

      builder.addCase(putSupportCategory.pending, (state) => {
        // state.loading = true;
      });
      builder.addCase(putSupportCategory.fulfilled, (state, action) => {
        state.loading = false; 
        console.log('Put Category Success: ', action.payload);

        const payload = action.payload?.created_data || action.payload?.updated_data || action.payload;
        const payloadId = payload?.textId || payload?.id;

        const updated = updateCategoryInTree(state.supportCenterCategory, payloadId, payload);
        
        if (!updated) {
          const index = state.supportCenterCategory.findIndex(item => item.textId === payloadId || item.id === payloadId);
          if (index !== -1) {
            state.supportCenterCategory[index] = {
              ...state.supportCenterCategory[index],
              ...payload,
            };
          }
        }

        state.error = "";
      });
      builder.addCase(putSupportCategory.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.error;
      });

      builder.addCase(deleteSupportCategory.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(deleteSupportCategory.fulfilled, (state, action) => {
        state.loading = false; 
        console.log('Delete Category Success: ', action.payload);

        const payload = action.payload;
        const payloadId = payload?.textId || payload?.id;
        state.supportCenterCategory = state.supportCenterCategory.filter(item => item.textId !== payloadId && item.id !== payloadId);

        state.error = "";
      });
      builder.addCase(deleteSupportCategory.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.error;
      });
       
      builder.addCase(fetchSupportCenterDocument.pending, (state) => {
        state.loading = true;
        state.supportCenterDocumentFetched = true;
      });
      builder.addCase(fetchSupportCenterDocument.fulfilled, (state, action) => {
        state.loading = false; 
        state.supportCenterDocument = action.payload.results;
        state.supportCenterDocumentFetched = true;
        state.error = "";
      });
      builder.addCase(fetchSupportCenterDocument.rejected, (state, action) => {
        state.loading = false; 
        state.supportCenterDocumentFetched = true;
        state.error = action.error;
      });

      builder.addCase(postSupportCenterDocument.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(postSupportCenterDocument.fulfilled, (state, action) => {
        state.loading = false; 
        console.log('Post Document Success: ', action.payload);
        state.supportCenterDocument.unshift(action.payload);
        state.error = "";
      });
      builder.addCase(postSupportCenterDocument.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.error;
      });

      builder.addCase(putSupportCenterDocument.pending, (state) => {
        // state.loading = true;
      });
      builder.addCase(putSupportCenterDocument.fulfilled, (state, action) => {
        state.loading = false; 
        console.log('Put Document Success: ', action.payload);

        const payload = action.payload?.created_data || action.payload?.updated_data || action.payload;
        const payloadId = payload?.textId || payload?.id;
        const index = state.supportCenterDocument.findIndex(item => item.textId === payloadId || item.id === payloadId);
        console.log('Document Index to update: ', index, 'payloadId:', payloadId);

        if (index !== -1) {
          const existingItem = state.supportCenterDocument[index];
          const updatedItem = {
            ...existingItem,
            ...payload,
          };

          if ((!updatedItem.mediaFiles || updatedItem.mediaFiles === '[]') && existingItem.mediaFiles) {
            updatedItem.mediaFiles = existingItem.mediaFiles;
          }

          state.supportCenterDocument[index] = updatedItem;
        }

        state.error = "";
      });
      builder.addCase(putSupportCenterDocument.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.error;
      });

      builder.addCase(deleteSupportCenterDocument.pending, (state) => {
        // state.loading = true;
      });
      builder.addCase(deleteSupportCenterDocument.fulfilled, (state, action) => {
        state.loading = false; 
        console.log('Delete Document Success: ', action.payload);
        const textId = action.meta.arg?.textId;
        state.supportCenterDocument = state.supportCenterDocument.filter(item => item.textId !== textId);
        state.error = "";
      });
      builder.addCase(deleteSupportCenterDocument.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.error;
      });
    },
  });
  
 
export const { appendCustomerChatItem, appendProviderChatItem } = disputeClaimSlice.actions;
export default disputeClaimSlice.reducer

 
